import {
  CREATE_ALERT_REQUEST,
  CREATE_ALERT_SUCCESS,
  CREATE_ALERT_FAILED,
  REMOVE_ALERT_REQUEST,
  REMOVE_ALERT_SUCCESS,
  REMOVE_ALERT_ERROR,
} from '../../sidebar/actions/alert';

export default (
  state = {
    sending: false,
    error: false,
    success: false,
  },
  action
) => {
  switch (action.type) {
    case REMOVE_ALERT_REQUEST:
    case CREATE_ALERT_REQUEST: {
      return {
        ...state,
        sending: true,
        error: false,
      };
    }
    case REMOVE_ALERT_SUCCESS:
    case CREATE_ALERT_SUCCESS: {
      return {
        ...state,
        sending: false,
        success: true,
      };
    }
    case REMOVE_ALERT_ERROR:
    case CREATE_ALERT_FAILED: {
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    }
    default:
    // Do nothing
  }
  return state;
};
